import { filterPromotionsByTypesMarketing } from '@services/products';

import { DiscountType } from '@app-types/discount';
import { CategoryListType } from '@app-types/plan';
import { PriceType } from '@app-types/price';

import { MarketingType, PlanTypeId } from '@constants/plan';

export const SimoSubCategories = [PlanTypeId.SIMO_SELECTION, PlanTypeId.SIMO_ENTRY, PlanTypeId.SIMO_MULTILIGNE];
export const PremiumSubCategories = [
    PlanTypeId.PREMIUM_SELECTION,
    PlanTypeId.PREMIUM_ENTRY,
    PlanTypeId.PREMIUM_MULTILIGNE,
];
export const ProSimoSubCategories = [PlanTypeId.SIMO_PRO_SELECTION];
export const ProPremiumSubCategories = [PlanTypeId.PREMIUM_PRO_SELECTION];

function getPromotionsAmount(promoList: DiscountType[]): number {
    return promoList.reduce((acc, promotion) => acc + promotion?.value, 0);
}

export function getPricesWithPromos(
    priceInitial: number,
    promos: DiscountType[],
    withTypeMarketing: MarketingType[],
    isConnected: boolean,
): PriceType {
    const prices: PriceType = {
        initial: priceInitial || 0,
        subsidized: priceInitial || 0,
        forever: priceInitial || 0,
        final: priceInitial || 0,
        promoLabel: '',
    };
    const appliedPromos: DiscountType[] = [];

    promos.forEach((promo) => applyPromo(promo, appliedPromos, prices, promos, isConnected, withTypeMarketing));
    const firstPromoWithLabel = appliedPromos.find((promo) => Boolean(promo?.pennant));
    prices.promoLabel = firstPromoWithLabel?.pennant || '';
    prices.duration = Math.max(...promos.map((promo) => promo.duration || 0));

    if (prices.forever && prices.final.toFixed(2) === prices.forever.toFixed(2)) {
        prices.duration = 0;
    }
    return prices;
}

function applyPromo(
    promo: DiscountType,
    appliedPromos: DiscountType[],
    prices: PriceType,
    promos: DiscountType[],
    isConnected: boolean,
    withTypeMarketing: MarketingType[],
) {
    const promoType = getPromoType(promo);

    if (!promoType || !withTypeMarketing.includes(promoType)) {
        return;
    }

    const promoAmount = getPromotionsAmount(
        filterPromotionsByTypesMarketing(
            promos,
            [promoType],
            [MarketingType.MULTILINE, MarketingType.PORTABILITY].includes(promoType) || !isConnected,
        ),
    );

    if (promoType === MarketingType.PORTABILITY) {
        prices.final -= promoAmount;
        prices.initial -= promoAmount;
        appliedPromos.push(promo);
    }

    if (promoType === MarketingType.MULTILINE) {
        if (promo.isIncitation) {
            prices.final -= promoAmount;
            prices.initial -= promoAmount;
        }
        appliedPromos.push(promo);
    }
}

export function orderPlansByCategorys(categoryList: CategoryListType): CategoryListType {
    const order = [...SimoSubCategories, ...PremiumSubCategories, ...ProSimoSubCategories, ...ProPremiumSubCategories];
    return categoryList.sort((a, b) => {
        return order.indexOf(a?.code as PlanTypeId) - order.indexOf(b?.code as PlanTypeId);
    });
}

function getPromoType(promo: DiscountType) {
    if (promo?.marketingTypes?.includes(MarketingType.PORTABILITY)) {
        return MarketingType.PORTABILITY;
    }

    if (promo?.marketingTypes?.includes(MarketingType.MULTILINE)) {
        return MarketingType.MULTILINE;
    }
}
